export class GCAttributeValue{
    constructor(
        public GCAttributeID: number,
        public GCAttributeValueName: string
    ){}
};

export class AttributeName{
    constructor(
        public GCAttributeName: string,
        public IsActive: boolean
    ){}
};



export class AttributeNames{
    constructor(
        public ID: number,
        public GCAttributeName: string,
        public GCAttributeSearchTypeID: number,
        public GCAttributeTypeID: number,
        public IsActive: boolean
    ){}
};

export class AttributeNameValues{
    constructor(
        public ID: number,
        public GCAttributeID: number,
        public GCAttributeValueName: string
    ){}
};

export class SourceValues{
   
        public Value: number;
        public ViewValue: string;
   
}